import { jsx } from "react/jsx-runtime";
import HelpCenterOutlinedIcon from "@mui/icons-material/HelpCenterOutlined";
import { validateTidalLicense } from "../../base/index.js";
function HelpCenterOutlined(props) {
  return /* @__PURE__ */ jsx(
    HelpCenterOutlinedIcon,
    {
      "data-testid": "HelpCenterOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "HelpCenterOutlined",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
HelpCenterOutlined.tidalIconMeta = {
  categories: "cancel,informative",
  name: "HelpCenterOutlined"
};
validateTidalLicense();
export {
  HelpCenterOutlined
};
//# sourceMappingURL=HelpCenterOutlined.js.map
